module.exports = __webpack_public_path__ + "static/media/sistemaPegar1.34d47c3b.jpg";